/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketstitle1Inputs */

const en_ticketstitle1 = /** @type {(inputs: Ticketstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

const de_ticketstitle1 = /** @type {(inputs: Ticketstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

/**
* | output |
* | --- |
* | "Tickets" |
*
* @param {Ticketstitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketstitle1 = /** @type {((inputs?: Ticketstitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketstitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketstitle1(inputs)
	return de_ticketstitle1(inputs)
});
export { ticketstitle1 as "ticketsTitle" }